import {
  Icon,
  Stack,
  Container,
  Text,
  Heading,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { FcGoogle } from "react-icons/fc";

// local imports
import useAuthContext from "../hooks/useAuthContext";
import { register } from "../services/auth";

const Register = () => {
  const { setUser } = useAuthContext();
  const secondaryTextColor = useColorModeValue("gray.600", "gray.400");

  const clickHandler = async () => {
    const user = await register();
    setUser(user);
  };

  return (
    <Container maxW="xl" py={{ base: 8, md: 12 }}>
      <Stack textAlign={"center"} spacing={{ base: 6, md: 8 }}>
        <Heading>Sign In / Sign Up</Heading>
        <Text color={secondaryTextColor}>
          Don't lose your tasklist, keep it synced with your Google account.
        </Text>
        <Button
          leftIcon={<Icon as={FcGoogle} w={6} h={6} />}
          onClick={clickHandler}
          size={"md"}
        >
          Continue with Google
        </Button>
      </Stack>
    </Container>
  );
};

export default Register;
